import { useQuery } from '@apollo/client/react';

import { listQuery } from '../../services/CredentialService';

export const useCredentials = (filter, { limit, offset }) => {
  const { data, loading, error } = useQuery(listQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { filter, limit, offset }
  });

  return { credentials: data?.credentials || [], loading, error };
};
